import { useState, useRef, useCallback, useEffect } from 'react';

import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import { faBroom } from '@fortawesome/free-solid-svg-icons';

import axios from 'axios';

const customStyles =
{
    control: (styles) =>
    ({
        ...styles,
        borderRadius: '0.75rem',
    })
}

const BusquedaAvanzada =
({
    verifyToken,
    setSelected,
    setBuscador,
    multiSelector,
    setMultiSelector,
    anioDesde,
    setAnioDesde,
    anioHasta,
    setAnioHasta,
    setCodigos,
    setCodigosProyectos,
    setCheckboxesProyectos,
    setProyectos,
    setAños,
    setAñosDisponibles,
    setCheckboxesAños,
    setCodigosRegiones,
    setCheckboxesRegiones,
    setRegiones,
    setCodigosSectores,
    setCheckboxesSectores,
    setSectores,
    setOrderbyAño,
    setOrderbyProyecto,
    setOrderbyInformacion,
    setOrderbyRegion,
    setOrderbySector,
    setOrderbyRegistros,
    setOrderby,
    setOrder,
    setArchivos,
    setLoading,
    handlePagination,
    handleSelector,
    setPages,
    division,
    pagination,
    setPagination,
    setFrom,
    setLastPage,
    setTo,
    setTotal,
    setPage,
    setStatus422,
    setOpcionesSelector,
    setAñosSelector,
    setTimestamp
}) =>
{
    const [fetch, setFetch] = useState(false);
    const [filter, setFilter] = useState(false);
    const [buscar, setBuscar] = useState(false);
    const [selector, setSelector] = useState([]);
    const [valueSelector, setValueSelector] = useState([]);
    const [rangoAños, setRangoAños] = useState([]);
    const [startYear, setStartYear] = useState([]);
    const [endYear, setEndYear] = useState([]);

    const valueDesdeRef = useRef();
    const valueHastaRef = useRef();

    const appDebug = process.env.REACT_APP_DEBUG;
    const apiUrl = process.env.REACT_APP_API_URL;
    const secretKey = process.env.REACT_APP_SECRET_KEY;

    const handleMultiSelector = (e) =>
    {
        setMultiSelector(e);
        setValueSelector(e);
    }

    const handleAnioDesde = (anio) =>
    {
        if (anio !== null)
        {
            setAnioDesde(anio.value);

            const endYear = [ { value: 'Elija el año hasta', label: 'Elija el año hasta', isDisabled: true }, ...rangoAños.filter(año => año.value >= anio.value) ];

            setEndYear(endYear);

            if (anio.value > anioHasta)
            {
                setEndYear([ { value: 'Elija el año hasta', label: 'Elija el año hasta', isDisabled: true }, ...rangoAños.filter(año => año.value >= anio.value) ]);
                setAnioHasta(null);

                valueHastaRef.current.clearValue();
            }
        }
    }

    const handleAnioHasta = (anio) =>
    {
        if (anio !== null)
        {
            setAnioHasta(anio.value);

            const startYear = [ { value: 'Elija el año desde', label: 'Elija el año desde', isDisabled: true }, ...rangoAños ];

            setStartYear(startYear);
        }
    }

    const handleBuscar = () =>
    {
        setSelected('');
        setBuscador({});

        setLoading(false);
        setPagination(1);
        setBuscar(true);
    }

    const filterData = useCallback(async () =>
    {
        setFilter(true);

        try
        {
            let selector = '';

            multiSelector.forEach(data =>
            {
                selector += '&multi_selector[]=' + data.value;
            });

            const responseBusqueda = await axios.get(`${apiUrl}${division}/busqueda?registros=1${selector}&anio_desde=${anioDesde}&anio_hasta=${anioHasta}&environment=local`);

            const busqueda = verifyToken(responseBusqueda, appDebug, secretKey);

            if (busqueda.length === 0) { return console.log(new Error('Signature is not valid.')); }

            setCodigos(busqueda.codigos);
            setProyectos(busqueda.proyectos);
            setAños(busqueda.anios);
            setRegiones(busqueda.regiones);
            setSectores(busqueda.sectores);
            setOrderbyAño(0);
            setOrderbyProyecto(0);
            setOrderbyInformacion(0);
            setOrderbyRegion(0);
            setOrderbySector(0);
            setOrderbyRegistros(0);
            setOrderby('');
            setOrder('');

            const responseArchivos = await axios.get(`${apiUrl}${division}/archivos?page=${pagination}${selector}&anio_desde=${anioDesde}&anio_hasta=${anioHasta}&environment=local`);

            const archivos = verifyToken(responseArchivos, appDebug, secretKey);

            if (archivos.length === 0) { return console.log(new Error('Signature is not valid.')); }

            setCodigosProyectos([]);
            setCheckboxesProyectos({});
            setAñosDisponibles([]);
            setCheckboxesAños({});
            setCodigosRegiones([]);
            setCheckboxesRegiones({});
            setCodigosSectores([]);
            setCheckboxesSectores({});
            setArchivos(archivos.data);

            const from = archivos.meta.from;
            const lastPage = archivos.meta.last_page;
            const to = archivos.meta.to;
            const total = archivos.meta.total;

            setLoading(true);
            setBuscar(false);
            setFilter(false);

            handlePagination(setPages, pagination, lastPage);

            setFrom(from);
            setLastPage(lastPage);
            setTo(to);
            setTotal(total);
            setStatus422(false);

            handleSelector();

            setTimestamp('');
        }
        catch (error)
        {
            const timestamp = error.response.data.timestamp;

            error.status === 422 && setStatus422(true);

            error.status === 422 && handleSelector();

            error.status === 422 && setTimestamp(timestamp);
            error.status === 422 && setBuscar(false);
            error.status === 422 && setFilter(false);
        }
    }, [appDebug, apiUrl, secretKey, verifyToken, handlePagination, handleSelector, multiSelector, anioDesde, anioHasta,
        setCodigos, setCodigosProyectos, setCheckboxesProyectos, setProyectos, setAñosDisponibles, setCheckboxesAños, setAños,
        setCodigosRegiones, setCheckboxesRegiones, setRegiones, setCodigosSectores, setCheckboxesSectores, setSectores,
        setOrderbyAño, setOrderbyProyecto, setOrderbyInformacion, setOrderbyRegion, setOrderbySector, setOrderbyRegistros, setOrderby, setOrder,
        setArchivos, setLoading, setPages, pagination, setFrom, setLastPage, setTo, setTotal, setStatus422, setTimestamp
    ]);

    const fetchData = useCallback(async () =>
    {
        setFetch(true);

        try
        {
            const response = await axios.get(`${apiUrl}${division}/busqueda?registros=0&environment=local`);

            const data = verifyToken(response, appDebug, secretKey);

            if (data.length === 0) { return console.log(new Error('Signature is not valid.')); }

            const proyectos = [ ...data.proyectos ];

            const selectorProyectos = proyectos.map(proyecto =>
            ({
                value: `D${proyecto.COD_PROYECTO}`,
                label: `Proyecto: ${proyecto.TIPO_INFORMACION}`,
            }));

            const tiposInformacion = [ ...data.tipos_informacion ];

            const selectorTiposInformacion = tiposInformacion.map(tipoInformacion =>
            ({
                value: `I${tipoInformacion.TIPO_INFORMACION}`,
                label: `Tipo de Información: ${tipoInformacion.TIPO_INFORMACION}`,
            }));

            const regiones = [ ...data.regiones ];

            const selectorRegiones = regiones.map(region =>
            ({
                value: `R${region.COD_REGION}`,
                label: `Región: ${region.NOMBRE_REG}`,
            }));

            const sectores = [ ...data.sectores ];

            const selectorSectores = sectores.map(sector =>
            ({
                value: `S${sector.SECTOR}`,
                label: `Sector: ${sector.SECTOR}`,
            }));

            setSelector([ ...selectorProyectos, ...selectorTiposInformacion, ...selectorRegiones, ...selectorSectores ]);

            const anios = [ ...data.anios ];

            const rangoAños = anios.map(anio =>
            ({
                value: `${anio.ANIO}`,
                label: `${anio.ANIO}`,
            }));

            const startYear = [ { value: 'Elija el año desde', label: 'Elija el año desde', isDisabled: true }, ...rangoAños ];
            const endYear = [ { value: 'Elija el año hasta', label: 'Elija el año hasta', isDisabled: true }, ...rangoAños ];

            setRangoAños(rangoAños);
            setStartYear(startYear);
            setEndYear(endYear);
        }
        catch (error)
        {
            console.error(error);
        }
    }, [appDebug, apiUrl, secretKey, verifyToken]);

    const handleReset = () =>
    {
        const startYear = [ { value: 'Elija el año desde', label: 'Elija el año desde', isDisabled: true }, ...rangoAños ];
        const endYear = [ { value: 'Elija el año hasta', label: 'Elija el año hasta', isDisabled: true }, ...rangoAños ];

        setMultiSelector([]);
        setValueSelector([]);
        setStartYear(startYear);
        setEndYear(endYear);
        setAnioDesde(null);
        setAnioHasta(null);
        setCodigos([]);
        setCodigosProyectos([]);
        setCheckboxesProyectos({});
        setProyectos([]);
        setAños([]);
        setCodigosRegiones([]);
        setCheckboxesRegiones({})
        setRegiones([]);
        setCodigosSectores([]);
        setCheckboxesSectores({})
        setSectores([]);
        setOrderbyAño(0);
        setOrderbyProyecto(0);
        setOrderbyInformacion(0);
        setOrderbyRegion(0);
        setOrderbySector(0);
        setOrderbyRegistros(0);
        setOrderby('');
        setOrder('')
        setArchivos([]);
        setLoading(false);
        setPages([]);
        setPagination(1);
        setFrom(0);
        setLastPage(0);
        setTo(0);
        setTotal(0);
        setPage(false);
        setStatus422(false);
        setOpcionesSelector('');
        setAñosSelector('');
        setTimestamp('');
        setBuscar(false);

        valueDesdeRef.current.clearValue();
        valueHastaRef.current.clearValue();
    }

    useEffect(() =>
    {
        fetch === false && fetchData();
    }, [fetchData, fetch]);

    useEffect(() =>
    {
        filter === false && buscar === true && filterData();
    }, [filterData, filter, buscar]);

    return (
        <div className="row pt-3">
            <div className="col">
                <div className="card h-100 border-0 bg-transparent">
                    <div className="card-body">
                        <div className="row g-2 ms-3 justify-content-md-center">
                            <div className="col-xl-6 col-lg-12">

                                {
                                    selector.length > 0 ?
                                    (
                                        <Select
                                            isMulti
                                            name="selector"
                                            value={valueSelector}
                                            onChange={handleMultiSelector}
                                            options={selector}
                                            placeholder="Seleccione al menos una especie, región, año, proyecto o tipo de información (*)"
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            styles={customStyles}
                                        />
                                    ) :
                                    (
                                        <Select
                                            isMulti
                                            name="selector"
                                            value={valueSelector}
                                            placeholder="Seleccione al menos una especie, región, año, proyecto o tipo de información (*)"
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            styles={customStyles}
                                            isDisabled
                                        />
                                    )
                                }

                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12">

                                {
                                    selector.length > 0 && rangoAños.length > 0 ?
                                    (
                                        <Select
                                            name="anio_desde"
                                            ref={valueDesdeRef}
                                            onChange={handleAnioDesde}
                                            options={startYear}
                                            placeholder="Elija el año desde (*)"
                                            className="basic-single"
                                            classNamePrefix="select"
                                            styles={customStyles}
                                        />
                                    ) :
                                    (
                                        <Select
                                            name="anio_desde"
                                            ref={valueDesdeRef}
                                            placeholder="Elija el año desde (*)"
                                            className="basic-single"
                                            classNamePrefix="select"
                                            styles={customStyles}
                                            isDisabled
                                        />
                                    )
                                }

                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12">

                                {
                                    selector.length > 0 && rangoAños.length > 0 ?
                                    (
                                        <Select
                                            name="anio_hasta"
                                            ref={valueHastaRef}
                                            onChange={handleAnioHasta}
                                            options={endYear}
                                            placeholder="Elija el año hasta (*)"
                                            styles={customStyles}
                                        />
                                    ) :
                                    (
                                        <Select
                                            name="anio_hasta"
                                            ref={valueHastaRef}
                                            placeholder="Elija el año hasta (*)"
                                            styles={customStyles}
                                            isDisabled
                                        />
                                    )
                                }

                            </div>
                            <div className="col-xl-1 col-lg-2 col-md-2 col-sm-12 text-end">

                                {
                                    multiSelector.length > 0 && anioDesde && anioHasta ?
                                    (
                                        <button type="button" className="btn btn-warning w-100" onClick={handleBuscar} disabled={buscar}><FontAwesomeIcon icon={faMagnifyingGlass} /><span className="ms-2">{'Buscar'}</span></button>
                                    ) :
                                    (
                                        <button type="button" className="btn btn-warning w-100" disabled><FontAwesomeIcon icon={faMagnifyingGlass} /><span className="ms-2">{'Buscar'}</span></button>
                                    )
                                }

                            </div>
                            <div className="col-xl-1 col-lg-2 col-md-2 col-sm-12 text-end">

                                {
                                    multiSelector.length > 0 && anioDesde && anioHasta ?
                                    (
                                        <button type="reset" className="btn btn-secondary w-100" onClick={handleReset} disabled={buscar}><span className="d-inline d-md-none d-lg-inline"><FontAwesomeIcon icon={faBroom} /></span><span className="ms-2">{'Limpiar'}</span></button>
                                    ) :
                                    (
                                        <button type="reset" className="btn btn-secondary w-100" disabled><span className="d-inline d-md-none d-lg-inline"><FontAwesomeIcon icon={faBroom} /></span><span className="ms-2">{'Limpiar'}</span></button>
                                    )
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BusquedaAvanzada;
